import { em } from 'polished'
import styled from 'styled-components'

import { BoxBase, Col } from 'styles/components/layout'

export const BoxBaseStyled = styled(BoxBase)`
  background: ${p => p.theme.colors.grayOp06NonTransp};
  margin-top: ${em(28)};
  padding-top: ${em(47)};
  padding-bottom: ${em(47)};

  ${p => p.theme.mq.upMd} {
    margin-top: ${em(80)};
    padding-top: ${em(47)};
    padding-bottom: ${em(24)};
  }

  ${p => p.theme.mq.upLg} {
    padding-top: ${em(62)};
    padding-bottom: ${em(68)};
  }
`

export const ColStyled = styled(Col)`
  margin-bottom: ${em(44)};

  ${p => p.theme.mq.upMd} {
    margin-bottom: ${em(46)};
  }
`

export const IconBox = styled.div`
  width: ${em(32)};
  height: ${em(32)};
  margin-bottom: ${em(9)};

  ${p => p.theme.mq.upMd} {
    width: ${em(42)};
    height: ${em(42)};
    margin-bottom: ${em(16)};
  }
`

export const IconText = styled.h6`
  font-family: ${p => p.theme.typography.mediumFont};
  font-size: ${p => p.theme.typography.cartItemFontSize};
  line-height: ${p => p.theme.typography.cartItemFontLh};
  margin-bottom: ${p => em(5, p.theme.typography.cartItemFontSizePx)};
  font-weight: 400;

  ${p => p.theme.mq.upMd} {
    font-family: ${p => p.theme.typography.mediumFont};
    font-size: ${p => p.theme.typography.fontSize};
    line-height: ${p => p.theme.typography.baseLh};
    margin-bottom: ${p => em(5, p.theme.typography.fontSizeBasePx)};
  }
`

export const IconDescription = styled.p`
  font-size: ${p => p.theme.typography.cartItemFontSize};
  line-height: ${p => p.theme.typography.cartItemFontLh};

  ${p => p.theme.mq.upMd} {
    font-size: ${p => p.theme.typography.textSmallDescr};
    line-height: ${p => p.theme.typography.textSmallDescrLh};
  }
`

export const IconWrapper = styled.div`
  width: ${em(20)};
  height: ${em(20)};
  flex-shrink: 0;
  margin-bottom: ${em(12)};
`

export const TextDisclaimerNew = styled.p`
  font-size: ${p => p.theme.typography.textSmallDescr};
  line-height: ${p => p.theme.typography.textDisclaimerLh};
`

export const Wrapper = styled.div`
  position: relative;
  opacity: ${p => p.theme.blocks.blockMutedOpacity};
`
